<template>
  <div>
    <b-row align-h="center" style="margin-bottom: 40px; text-align: center">
      <b-col cols="12" md="5">
        <h4 class="font-weight-bold mb-4">Select Amount</h4>
        <span class="fire mb-2">🔥 Limited time. Pay what you can afford</span>
        <h5 class="mb-4">{{membershipText}}</h5>
        <div class="range-container">
          <div class="d-flex flex-column align-items-center mb-3">
            <span class="price-approx">{{approxText}}</span>
            <span class="price-text mb-1" v-bind:class="textRule">${{ rangeVal}}</span>
            <span class="price-per-month">/month</span>
          </div>
          <div class="d-inline-block w-100 mb-5 px-3">
            <vue-slider
              v-model="rangeVal"
              :tooltip="'none'"
              :min="min"
              :max="max"
              :dot-size="32"
              :dot-style="{background:'#224181'}"
              :rail-style="{backgroundColor:'#AAAAAA'}"
              :contained="true"
              :marks="marks"
              @change="selectPrice"
            >
              <template v-slot:mark="{ pos, label }" v-if="recurring === true">
                <div class="custom-mark-start" v-if="label === lowestPrice">
                  ${{ label }}
                </div>
                <div v-else-if="label === defaultPrice" class="custom-mark" :style="{ left: `${pos}%` }">
                  <font-awesome-icon :icon="['fas', 'caret-up']" size="3x" class="arrow" ></font-awesome-icon>
                  <div class="recommend-text">Recommended Price</div>
                </div>
                <div v-else-if="label === max" class="custom-mark-end">
                  ${{ label }}
                </div>
              </template>
              <template v-slot:mark="{ pos, label }" v-else-if="!recurring">
                <div class="custom-mark-start" v-if="label === lowestPrice">
                  ${{ label }}
                </div>
                <div class="custom-mark" :style="{ left: `${pos}%` }" v-if="label === defaultPrice">
                  <font-awesome-icon :icon="['fas', 'caret-up']" size="3x" class="arrow" ></font-awesome-icon>
                  <div class="recommend-text">Recommended Price</div>
                </div>
                <div v-else-if="label === max" class="custom-mark-end">
                  ${{ label }}
                </div>
              </template>
            </vue-slider>
          </div>
          <div class="info-text d-inline-block w-90 mt-2" v-bind:class="infoTextColor">
            {{infoTextRule}}
          </div>
          <template>
            <button class="btn btn-primary btn-block mb-3 mt-5" @click="pay">Change Amount</button>
            <div class="text-center d-flex flex-column align-items-center">
              <span  style="margin-top:5px;margin-bottom: -3px;">*All prices exclusive of Stripe fees</span>
              <span >*1% additional fee will be added for countries outside US</span>
            </div>
          </template>

        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from 'vue';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import { mapActions, mapGetters } from 'vuex';
import helperMixins from '../mixins/helpers.mixins';

const BASE_URL = process.env.BASE_URL;
export default {
  name: 'ChangeSubscriptionPage',
  mixins: [helperMixins],
  data() {
    return {
      list: [],
      selectedPlan: null,
      subscribeData: {
        country: '',
        currency: '',
        identifier: '',
        price: 0,
        lowest_price: 0,
        recurring: true,
        defaultPrice: 0,
        paymentMethod: 'credit_card',
        checkout_url: '',
      },
      rangeVal: 1,
      min: 1,
      max: 100,
      marks: false,
      recurring: null,
      defaultPrice: 1,
      lowestPrice: 1,
    };
  },
  // eslint-disable-next-line consistent-return
  async mounted() {
    this.list = [];
    if (this.changeSubsTrxData !== '') {
      Vue.swal({
        title: 'Warning',
        text: 'The other transaction is on the way. Please finish it before create new transaction',
        icon: 'warning',
        confirmButtonText: 'Continue Payment',
        cancelButtonText: 'Cancel Transaction',
        showConfirmButton: true,
        showCancelButton: true,
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-danger',
        },
      }).then(async (result) => {
        if (result.value) {
          await this.$stripe.redirectToCheckout({
            sessionId: this.subscriptionTrxData.session_id,
          });
        } else {
          this.removePaymentDataSubscription();
          this.$router.push({ name: 'HomePage' });
        }
      });
    } else {
      await this.requestDetailUser();
      if (this.getUser.data.type === 1) {
        await this.requestListSubscription();
        if (this.getStatus === 401) {
          Vue.swal({
            title: 'Happy Sabbath!',
            text: this.getMessage,
            confirmButtonText: 'Yes',
            cancelButtonText: 'Back to Home',
            showConfirmButton: false,
            showCancelButton: true,
          }).then(async () => {
            this.$router.push({ name: 'HomePage' });
          });
        } else if (this.getStatus !== 200) {
          Vue.swal({
            title: this.getStatus,
            text: this.getMessage,
            icon: 'warning',
            confirmButtonText: 'Yes',
            cancelButtonText: 'Back to Home',
            showConfirmButton: false,
            showCancelButton: true,
          }).then(async () => {
            this.$router.push({ name: 'HomePage' });
          });
        } else {
          // this.defaultPrice = this.getUser.data.subscription.current_amount;
          this.rangeVal = this.getUser.data.subscription.current_amount;
        }
      } else {
        return this.$router.push({ name: 'HomePage' });
      }
    }
  },
  computed: {
    ...mapGetters('CreditsAmountModule', ['listSubscriptionPrice']),
    ...mapGetters('PaymentModule', ['subscriptionTrxData', 'paymentPending', 'changeSubsTrxData']),
    ...mapGetters('NotificationModule', ['getLoading', 'getStatus', 'getMessage', 'getErrorCode']),
    ...mapGetters('AuthModule', ['getUser']),
    approxText() {
      if (this.marks) {
        const price = (this.rangeVal * this.subscribeData.rate).toFixed(2);
        return `Approx ${this.subscribeData.user_currency} ${this.formatPrice(price)}`;
      }
      return '';
    },
    textRule() {
      let rule = '';
      if (this.subscribeData.price === this.subscribeData.lowest_price) {
        rule = 'rule-1-price';
      } else if (this.subscribeData.price > this.subscribeData.lowest_price && this.subscribeData.price <= this.subscribeData.defaultPrice) {
        rule = 'rule-2-price';
      } else if (this.subscribeData.price > this.subscribeData.defaultPrice && this.subscribeData.price < 20) {
        rule = 'rule-3-price';
      } else if (this.subscribeData.price >= 20 && this.subscribeData.price < 50) {
        rule = 'rule-4-price';
      } else if (this.subscribeData.price >= 50 && this.subscribeData.price < 100) {
        rule = 'rule-5-price';
      } else if (this.subscribeData.price >= 100) {
        rule = 'rule-6-price';
      }
      return rule;
    },
    infoTextRule() {
      let rule = '';
      if (this.subscribeData.price === this.subscribeData.lowest_price) {
        rule = 'If you can’t afford the suggested price. You can lower the number to pay what you can afford';
      } else if (this.subscribeData.price > this.subscribeData.lowest_price && this.subscribeData.price <= this.subscribeData.defaultPrice) {
        rule = 'If you can’t afford the suggested price. You can lower the number to pay what you can afford';
      } else if (this.subscribeData.price > this.subscribeData.defaultPrice && this.subscribeData.price < 20) {
        rule = '';
      } else if (this.subscribeData.price >= 20 && this.subscribeData.price < 50) {
        rule = 'Thank you for being a cheerful giver. You\'re on the top 1% subscribers who input $20 or more.';
      } else if (this.subscribeData.price >= 50 && this.subscribeData.price < 100) {
        rule = 'We are grateful for your generosity. You\'re on the top 0.5% subscribers who input $50 or more.';
      } else if (this.subscribeData.price >= 100) {
        rule = 'You\'re awesome! We thank you for your abundant support on MusicVerse & missions.';
      }
      return rule;
    },
    infoTextColor() {
      let rule = '';
      if (this.subscribeData.price >= 20 && this.subscribeData.price < 50) {
        rule = 'rule-4-info';
      } else if (this.subscribeData.price >= 50 && this.subscribeData.price < 100) {
        rule = 'rule-5-info';
      } else if (this.subscribeData.price >= 100) {
        rule = 'rule-6-info';
      }
      return rule;
    },
    membershipText() {
      return 'Monthly Premium Membership';
    },
  },
  watch: {
    listSubscriptionPrice: {
      immediate: true,
      deep: true,
      async handler() {
        if (this.listSubscriptionPrice != undefined && this.listSubscriptionPrice != null) {
          const subs = this.listSubscriptionPrice;
          this.subscribeData = {
            ...subs,
            country: subs.country,
            currency: subs.currency,
            identifier: subs.identifier.replaceAll('-', '_'),
            price: subs.price,
            defaultPrice: subs.price,
            recurring: true,
            paymentMethod: 'credit_card',
          };
          this.defaultPrice = subs.price;
          this.lowestPrice = subs.lowest_price;
          this.min = subs.lowest_price;
          this.rangeVal = subs.price;
          this.marks = true;
          this.max = 100;
        }
      },
    },
  },
  methods: {
    ...mapActions('CreditsAmountModule', ['requestListSubscription']),
    ...mapActions('PaymentModule', ['setPaymentDataSubscription', 'removePaymentDataSubscription',
      'requestMakePaymentSubscription', 'requestChangeAmountSubscription', 'setPaymentDataChangeSubs', 'removePaymentDataChangeSubs']),
    ...mapActions('NotificationModule', ['setLoading', 'unsetLoading']),
    ...mapActions('AuthModule', ['requestDetailUser']),
    selectPrice(val) {
      this.subscribeData = { ...this.subscribeData, price: val };
    },
    async pay() {
      this.subscribeData = { ...this.subscribeData, recurring: this.recurring };
      await this.payStripe();
    },
    async payStripe() {
      const dataSend = {
        currency: this.subscribeData.currency,
        amount: this.subscribeData.price,
      };
      const session = await this.requestChangeAmountSubscription(dataSend);
      this.setPaymentDataChangeSubs({
        currency: this.subscribeData.currency,
        amount: this.subscribeData.price,
      });
      this.setLoading();
      if(this.getStatus === 400 && this.getErrorCode === 'change-amount-subs'){
        this.$swal('Something Wrong. Please Try Again', '', 'error');
      }else{
        this.$router.push({ name: 'ChangeSubscriptionSuccessPage' });
      }
      this.unsetLoading();
    },
  },
  components: {
    VueSlider,
  },
};
</script>

<style scoped>
.btn-back{
  background: #C4C4C4;
  display: flex;
  width: 42px;
  height: 42px;
  cursor: pointer;
}
.icon-back{
  display: inline-block;
  margin: auto;
  color: #000000;
  font-size: 1.5rem;
}
.label-credits{
  margin-right:174px;
}
.checked-credit{
  margin-bottom: 40px;
}
.fire{
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #EA614F;
}
.range-container{
  padding: 32px;
  background: rgba(204, 204, 255,0.24);
  border-radius: 24px;
  margin-bottom: 40px;
}
.price-approx{
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  text-align: center;
  color: #224181;
}
.price-text{
  font-style: normal;
  font-weight: bold;
  font-size: 36px;
  line-height: 43px;
  text-align: center;
}
.price-per-month{
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
}

.info-text{
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  color: #767676;
}

.rule-1-price{
  color:#F57474;
}
.rule-2-price{
  color:#224181;
}
.rule-3-price{
  color:#224181;
}
.rule-4-price{
  color:#0A84FF;
}
.rule-5-price{
  color:#5856D6;
}
.rule-6-price{
  color:#FF9F0A;
}
.rule-4-info{
  font-weight: 700;
  color:#0A84FF;
}
.rule-5-info{
  font-weight: 700;
  color:#5856D6;
}
.rule-6-info{
  font-weight: 700;
  color:#FF9F0A;
}
.w-90{
  width: 90%;
  height: 34px;
}
@media all and (min-width: 768px) {
  .duration-container{
    max-width: 350px;
    margin: 0 auto;
  }

  .payment-container{
    max-width: 370px;
    margin: 0 auto;
  }
}
.duration-item{
  margin-bottom:24px;
}
.line-separator{
  height: 1px;
  width: 100%;
  background: #D9D9D9;
  margin-top:18px;
  margin-bottom: 24px;
}
.small-muted-text{
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #767676;
  margin-bottom: 18px;
}
.input-radio{
  margin-right: 26px;
  padding-top:4px;
}
.duration-text{
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  color: #4D4D4D;
  text-align: left;
  margin-bottom: 10px;
}
.duration-images img{
  width: auto;
  height: 16px;
  margin-right: 9px;
}
.payment-item{
  margin-bottom: 40px;
}
.input-radio-payment{
  margin-right: 26px;
}
.payment-method-label{
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  color: #4D4D4D;
}
.payment-method-images img{
  width: auto;
  height: 16px;
  margin-left: 6px;
}
</style>



// WEBPACK FOOTER //
// src/views/ChangeSubscription.vue